module.exports = __webpack_public_path__ + "static/media/error-on.8822bbac.png";